import { render, staticRenderFns } from "./DeadlineSearch.vue?vue&type=template&id=5bffa226&scoped=true"
import script from "./DeadlineSearch.vue?vue&type=script&lang=ts"
export * from "./DeadlineSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bffa226",
  null
  
)

export default component.exports